module.exports = __webpack_public_path__ + "static/img/room_ln.241e5af0.png";